export default "__VITE_ASSET__DqzkdFf7__"